import { Applicant } from "types/application";
import type { BankStatements, EditTransactionsModalData } from "../../types";
import { CombinedIncome } from "../../types/income";
import { EditTransactions } from "./EditTransactions";
import { Modal, Show } from "shared/components";

type Props = Partial<EditTransactionsModalData> & {
  opened: boolean;
  onClose: () => void;
  applicant: Applicant;
  verificationId: number;
  applicationId: number;
  income?: CombinedIncome;
  allBankStatements?: BankStatements;
  onSuccess?: () => void;
};

export const EditTransactionsModal = (props: Props) => {
  const { onClose, opened } = props;

  return (
    <Modal
      panelClassName="w-full h-fit max-h-[90vh] max-w-[90vw] lg:max-w-[800px]"
      onClose={onClose}
      opened={opened}
    >
      <Show if={opened}>
        <EditTransactions {...props} />
      </Show>
    </Modal>
  );
};
